import { configureStore } from "@reduxjs/toolkit";
import React from "react";
import { TypedUseSelectorHook, createDispatchHook, createSelectorHook } from "react-redux";
import capacitySlice from "./capacitySlice";

export const CapacityContext = React.createContext(null);

const capacityStore = configureStore({
    reducer: {
        capacityStore: capacitySlice,
    },
});
export default capacityStore;

export type State = ReturnType<typeof capacityStore.getState>;
export type Dispatch = typeof capacityStore.dispatch;
export const useCapacitySelector: TypedUseSelectorHook<State> = createSelectorHook(CapacityContext);
export const useCapacityDispatch = createDispatchHook<Dispatch>(CapacityContext);
